// Iscrizione "avvisami quando torna disponibile" tramite l'API client pubblica di Klaviyo.
// Richiede il catalogo Shopify sincronizzato in Klaviyo e il flusso "Back in stock" attivo.
if (!window.mqBackInStockLoaded) {
  window.mqBackInStockLoaded = true;

  const KLAVIYO_COMPANY_ID = 'VyEqVB';
  const ENDPOINT = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${KLAVIYO_COMPANY_ID}`;
  const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const showMessage = (form, text, isError) => {
    const message = form.querySelector('.back-in-stock__message');
    message.textContent = text;
    message.classList.toggle('back-in-stock__message--error', Boolean(isError));
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest?.('.back-in-stock__form');
    if (!form) return;
    event.preventDefault();

    const input = form.querySelector('.back-in-stock__input');
    const button = form.querySelector('.back-in-stock__submit');
    const email = input.value.trim();

    if (!EMAIL_PATTERN.test(email)) {
      showMessage(form, 'Inserisci un indirizzo email valido.', true);
      input.focus();
      return;
    }

    button.disabled = true;
    showMessage(form, '', false);

    try {
      const response = await fetch(ENDPOINT, {
        method: 'POST',
        headers: {
          revision: '2026-07-15',
          'Content-Type': 'application/vnd.api+json',
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: { data: { type: 'profile', attributes: { email } } },
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${form.dataset.variantId}`,
                },
              },
            },
          },
        }),
      });

      if (response.status !== 202) throw new Error(`Klaviyo ${response.status}`);

      form.dataset.state = 'done';
      showMessage(form, 'Fatto! Ti scriveremo appena questo articolo torna disponibile.', false);
    } catch (error) {
      console.error(error);
      showMessage(form, 'Non siamo riusciti a registrare la richiesta. Riprova tra poco.', true);
      button.disabled = false;
    }
  });
}
